// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2ATsw","row":"Node_row__3z-VJ","label":"Node_label__2wI7G","footer":"Node_footer__387FN"};